import React from 'react'

import { BiUser } from 'react-icons/bi'
import { BsGrid } from 'react-icons/bs'
import { GrAchievement } from 'react-icons/gr'
import { HiOutlineLogout } from 'react-icons/hi'
import { LiaUserEditSolid } from 'react-icons/lia'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import { useUser } from '../../../context'
import { RoleTone } from '../../constants'

import { Logo, MenuItem, MenuItems, Navigation, Sidebar } from './styles'

interface SidebarNavigationProps {
  open: boolean
  role: RoleTone
  onNavigate: () => void
}

const menuItems = [
  { label: 'Principal', path: '/redesign/dashboard', Icon: BsGrid },
  { label: 'Perfil', path: '/perfil', Icon: BiUser, editProfile: false },
  {
    label: 'Editar perfil',
    path: '/perfil?edit=true',
    Icon: LiaUserEditSolid,
    editProfile: true,
  },
  { label: 'Desafíos', path: '/desafios', Icon: GrAchievement },
]

const SidebarNavigation = ({
  onNavigate,
  open,
  role,
}: SidebarNavigationProps) => {
  const location = useLocation()
  const navigate = useNavigate()
  const { setOnEditionMode, signOut } = useUser()

  const selectItem = (path: string, editProfile?: boolean) => {
    setOnEditionMode(editProfile ?? false)
    navigate(editProfile === undefined ? path : '/perfil')
    onNavigate()
  }

  const logout = () => {
    signOut()
    navigate('/')
  }

  return (
    <Sidebar $open={open} $role={role}>
      <Navigation
        id="redesign-primary-navigation"
        aria-label="Navegación principal"
      >
        <Logo $open={open}>
          <Link to="/redesign/dashboard" onClick={onNavigate}>
            <img src="/assets/icons/book-square.svg" alt="" />
            <strong>Diga-ah!</strong>
          </Link>
        </Logo>

        <MenuItems $open={open}>
          {menuItems.map(({ editProfile, label, path, Icon }) => (
            <MenuItem
              key={label}
              type="button"
              $open={open}
              $active={
                path === '/redesign/dashboard'
                  ? location.pathname === path
                  : location.pathname.startsWith(path.split('?')[0])
              }
              aria-label={!open ? label : undefined}
              title={!open ? label : undefined}
              onClick={() => selectItem(path, editProfile)}
            >
              <Icon aria-hidden="true" />
              {open && <span>{label}</span>}
            </MenuItem>
          ))}

          <MenuItem
            type="button"
            $open={open}
            className="logout"
            aria-label={!open ? 'Cerrar sesión' : undefined}
            title={!open ? 'Cerrar sesión' : undefined}
            onClick={logout}
          >
            <HiOutlineLogout aria-hidden="true" />
            {open && <span>Cerrar sesión</span>}
          </MenuItem>
        </MenuItems>
      </Navigation>
    </Sidebar>
  )
}

export default SidebarNavigation
